<script setup>
// Follow button, drawn by Trailhead (and so by Backyard and Hub, which
// redraw Trailhead's classes). The shared half is ../followBlock.js;
// the dialog is ../FollowDialog.vue. See Blocks/FollowBlock.vue.
import { computed } from 'vue';
import FollowDialog from '../FollowDialog.vue';
import { FOLLOW_DEFAULTS, useFollowBlock } from '../followBlock.js';
import { styleVars } from './shared.js';

const props = defineProps({
    config: { type: Object, required: true },
    accent: { type: String, default: '' },
    org: { type: Object, default: () => ({}) },
    site_data: { type: Object, default: () => ({}) },
});

const f = useFollowBlock(props);
const { open, start, busy, isFollowing, appUrl, canFollow, editing } = f;
const label = computed(() => props.config.button_label || FOLLOW_DEFAULTS.button_label);
</script>

<template>
    <section v-if="canFollow || editing" :id="config.anchor_id || null" class="th-block th-follow th-tint" :style="styleVars(config)">
        <div class="th-wrap th-band--short th-follow__inner">
            <div class="th-follow__copy">
                <h2 v-if="config.heading" class="th-h2 th-follow__title">{{ config.heading }}</h2>
                <p v-if="config.summary" class="th-body th-follow__body">{{ config.summary }}</p>
            </div>
            <button type="button" class="th-btn th-follow__btn" data-tiq-follow-btn
                    :class="isFollowing ? 'th-btn--quiet' : 'th-btn--primary'"
                    :aria-pressed="isFollowing" :disabled="busy" @click="f.openFollow">
                {{ isFollowing ? 'Following' : label }}
            </button>
        </div>
        <FollowDialog v-if="open" :key="start" :org="org" :app-url="appUrl" :start="start"
                      @open-app="f.openApp" @close="open = false" />
    </section>
</template>

<style scoped>
.th-follow__inner {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 20px 32px;
}
.th-follow__copy { max-width: 620px; }
.th-follow__title { font-size: clamp(26px, 3vw, 36px); line-height: 1.05; font-stretch: 106%; margin-bottom: 8px; }
.th-follow__body { font-size: 16px; color: var(--text-sub, #454a44); margin: 0; }
.th-follow__btn { flex: none; }
</style>
